const existsInIDMAP = {
  imageLabel: true,
  imageUrl: true,
  subtitle: true,
  cellBgColor: true,
  tooltip: true,
};

export function create(id, props) {
  if (!id) {
    throw new Error('Attribute Expressions Util: ID required');
  } else if (!existsInIDMAP[id]) {
    throw new Error('Attribute Expressions Util: ID missing from ID map');
  }
  const ret = {};
  if (props) {
    Object.keys(props).forEach((key) => {
      ret[key] = props[key];
    });
  }
  ret.qLabel = id;
  return ret;
}

export function getIndexById(attributeExpressions, id, idProp) {
  let index = -1;
  if (attributeExpressions) {
    const resolvedIdProp = idProp || 'qLabel';
    attributeExpressions.forEach((entry, i) => {
      if (entry[resolvedIdProp] === id) {
        index = i;
      }
    });
  }
  return index;
}

// Property-panel expression convert functions that read/write a single attribute expression (identified by
// `id`, stored as `qLabel`) in qListObjectDef.qExpressions.
export function getExpressionConvertFunctions(id) {
  return {
    get(_getter, _definition, _args, itemData) {
      const expressions = itemData.qListObjectDef?.qExpressions ?? [];
      const index = getIndexById(expressions, id, 'qLabel');
      return index > -1 ? expressions[index].qExpr : '';
    },
    set(value, _setter, _definition, _args, itemData) {
      const listObjectDef = itemData.qListObjectDef;
      listObjectDef.qExpressions = listObjectDef.qExpressions || [];
      const index = getIndexById(listObjectDef.qExpressions, id, 'qLabel');
      if (value) {
        const entry = create(id, { qExpr: value });
        if (index > -1) {
          listObjectDef.qExpressions[index] = entry;
        } else {
          listObjectDef.qExpressions.push(entry);
        }
      } else if (index > -1) {
        listObjectDef.qExpressions.splice(index, 1);
      }
    },
  };
}
